export default "__VITE_ASSET__f0t_yBvn__"